import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { getCookie } from '../../../../utils/getCookies';
import { markAllAsTouched } from '../../../../utils/markAllAsTouched';
import { QuillModule } from 'ngx-quill';
import { ModalGeneralComponent } from '../../../user/modals/modal-general/modal-general.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-step-3',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule, MatInputModule, MatSelectModule, MatButtonModule, QuillModule, TranslateModule],
  templateUrl: './step-3.component.html',
  styleUrl: './step-3.component.scss'
})
export class Step3Component implements AfterViewInit {

  selectedCualitiesDepartment:any = {
    "collaborative": "Colaborativo",
    "empathetic": "Empático",
    "inclusive": "Inclusivo",
    "customerOriented": "Orientado al cliente",
    "innovative": "Innovador",
    "creative": "Creativo",
    "adaptable": "Adaptable",
    "proactive": "Proactivo",
    "resultsOriented": "Orientado a resultados",
    "highPerformance": "Alto rendimiento",
    "processOriented": "Orientado a procesos",
    "transparent": "Transparente",
    "ethical": "Ético",
    "analytical": "Analítico",
    "qualityOriented": "Orientado a la calidad",
    "resilience": "Resiliente",
    "hierarchical": "Jerárquico",
    "bureaucratic": "Burocrático"
}


rasgos:{[key:string]:string} = {"charismatic": "Carismático", "authoritative": "Autoritario", "democratic": "Democrático", "laissezFaire": "Laissez Faire"};
descripcion_rasgos:{[key:string]:string} = {"charismatic": "Conecta fácilmente y transmite energía.", "authoritative": "Decide con rapidez y marca el rumbo.", "democratic": "Fomenta la participación del equipo.", "laissezFaire": "Da autonomía y confía en el equipo."};
comportamientos:{[key:string]:string} = {"taskoriented": "Orientado a tareas", "relationoriented": "Orientado a relaciones"};
descripcion_comportamientos:{[key:string]:string} = {"taskoriented": "Se centra en objetivos y resultados.", "relationoriented": "Cuida el ambiente y los vínculos."};
gestiones:{[key:string]:string} = {"motivational": "Motivacional", "transactional": "Transaccional"};
descripcion_gestiones:{[key:string]:string} = {"motivational": "Impulsa al equipo desde la inspiración.", "transactional": "Gestiona con acuerdos y seguimiento."};


  jobOfferForm: FormGroup;

  constructor(private fb: FormBuilder,  private route: ActivatedRoute, private router: Router, private http: HttpClient, public dialog: MatDialog, private translate: TranslateService) {
    this.jobOfferForm = this.fb.group({
      Cualities_department: [[], [Validators.required]],
      Other_cualities: [''],
      personality: [[], [Validators.required]],
      behavior: [[], [Validators.required]],
      management: [[], [Validators.required]],
      offer_id: [""]
    });
 
  }


  loading = false;
  step = 3;
  message_saved = '';
  goToStep(step: number) {
    this.router.navigate(['/dashboard/company/create-job-offer/step-' + step], { queryParams: { offer_id: this.jobOfferForm.get('offer_id')?.value } });
  } 

  addcategory(category:any){
    // ponemos touched como true
    this.jobOfferForm.get('Cualities_department')?.markAsTouched();
    if (!this.jobOfferForm.get('Cualities_department')?.value.includes(category)){
      this.jobOfferForm.get('Cualities_department')?.value.push(category);
      
    }
    else {
      this.jobOfferForm.get('Cualities_department')?.value.splice(this.jobOfferForm.get('Cualities_department')?.value.indexOf(category), 1);
    }
    
    // si el valor de la lista es mayor o igual a 1 quitar el error de requiered
    if (this.jobOfferForm.get('Cualities_department')?.value.length >= 1){
      this.jobOfferForm.get('Cualities_department')?.setErrors(null);
    }
    else{
      this.jobOfferForm.get('Cualities_department')?.setErrors({'required': true});
    }


  }
  goBack() {
    this.router.navigate(['/dashboard/company/create-job-offer/step-' + (this.step - 1)], { queryParams: { offer_id: this.jobOfferForm.get('offer_id')?.value } });
  }

   ngAfterViewInit() {
    this.route.queryParams.subscribe(params => {
      let offerId = params['offer_id'];
      if (offerId) {
        this.loadJobOffer(offerId);
      }
    });

  }

  save_progress(is_next: boolean = false) {
      this.loading = true;
      this.formHasError = false;
      this.nameError = false;

      const accessToken = getCookie('access_token');
          const headers = new HttpHeaders({
              'Authorization': `Bearer ${accessToken}`
          });

          var dataForm = this.jobOfferForm.value;
          dataForm["is_next"] = is_next;
  

        if (this.jobOfferForm.valid || !is_next){
          this.http.post(environment.url + '/api/v1/jobOfferStep3', dataForm, {headers: headers}).subscribe(
            (data: any) => {
              if (is_next) {
                this.router.navigate(['/dashboard/company/create-job-offer/step-4'], { queryParams: { offer_id:  this.jobOfferForm.get('offer_id')?.value } });
              }
              else{
                this.loading = false;
                this.dialog.open(ModalGeneralComponent, {
                  data: {
                    title: this.translate.instant('createJobOffer.step3.modals.saved.title'),
                    message: this.translate.instant('createJobOffer.step3.modals.saved.message'),
                    buttonText: this.translate.instant('createJobOffer.step3.modals.saved.buttonText'),
                    type: 'success'
                  }
                });

            }
            },
            (error) => {
              console.log(error);
              this.loading = false;
              this.dialog.open(ModalGeneralComponent, {
                data: {
                  title: this.translate.instant('createJobOffer.step3.modals.error.title'),
                  message: this.translate.instant('createJobOffer.step3.modals.error.message'),
                  buttonText: this.translate.instant('createJobOffer.step3.modals.error.buttonText'),
                  type: 'error'
                }
              });
            });
        }
      else {
        this.dialog.open(ModalGeneralComponent, {
          data: {
            title: this.translate.instant('createJobOffer.step3.modals.invalid.title'),
            message: this.translate.instant('createJobOffer.step3.modals.invalid.message'),
            buttonText: this.translate.instant('createJobOffer.step3.modals.invalid.buttonText'),
            type: 'error'
          }
        });

        this.jobOfferForm.markAllAsTouched();

      this.loading = false;
     }
      
    }

    formHasError = false;
    nameError = false;
  
    nextStep() {
      this.save_progress(true);
    }

    loadJobOffer(offerId: number) {
      const accessToken = getCookie('access_token');
          const headers = new HttpHeaders({
              'Authorization': `Bearer ${accessToken}`
          });
  
      this.http.get(environment.url + '/api/v1/getjobOffer', {headers: headers, params: {offer_id: offerId}}).subscribe((data: any) => {
        let offer = data["joboffer"];


        // we have to parse the values to the correct format
        if (typeof offer["personality"] === 'object'){
          offer["personality"] = offer["personality"][0]
        }
        if (typeof offer["behavior"] === 'object'){
          offer["behavior"] = offer["behavior"][0]
        }
        if (typeof offer["management"] === 'object'){
          offer["management"] = offer["management"][0]
        }


        this.jobOfferForm.patchValue(offer);

        
        this.jobOfferForm.get('offer_id')?.setValue(offer.id);
          
      }, (error: any) => {
        console.log(error);
      });
    }
    

}
